import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Button, Form, Alert, Spinner } from 'react-bootstrap';
import { useAuth } from '../../context/AuthContext';
import { format, addDays } from 'date-fns';

import {
    sendOtpApi, verifyOtpApi, registerWithOtpApi,
    applyToRoleApi, fetchRoleSceneScriptByIdApi, updateApplicationPaymentStatusApi,
    fetchRoleCheckApplicationByIdApi, uploadAuditionVideoApi, fetchCurrentAuditionDetailsApi,
    fetchRoleSchedulePublicByIdApi,redeemCoupon,confirmCouponUsage,  createPaymentOrderApi,
    verifyPaymentApi,
    getActiveGatewayApi
} from '../../services/api';
// import {redeemCoupon} from '../../services/adminApi';

// --- NEW IMPORTS FOR SUB-COMPONENTS ---
import WizardStepper from '../audition-booking-wizard/WizardStepper';
import WizardHeader from '../audition-booking-wizard/WizardHeader';
import Step1_SelectMode from '../audition-booking-wizard/Step1_SelectMode';
import Step2_Payment from '../audition-booking-wizard/Step2_Payment';
import Step3_ScriptScene from '../audition-booking-wizard/Step3_ScriptScene';
import Step4_UploadVideo from '../audition-booking-wizard/Step4_UploadVideo';
import Step5_ApplicationDetails from '../audition-booking-wizard/Step5_ApplicationDetails';
import PaymentModal from '../audition-booking-wizard/PaymentModal';
// import VideoPlayModal from './audition-booking-wizard/VideoPlayModal'; // VideoPlayModal moved inside Step5
import { JOGET_BASE_URL, MAX_SIZE_MB, MAX_DURATION_SEC, COMPRESS_THRESHOLD_MB } from '../audition-booking-wizard/utils/videoCompression';
import { clientCompress } from '../audition-booking-wizard/utils/videoCompression';
import { WIZARD_STEPS } from '../audition-booking-wizard/utils/bookingHelpers'; 

import './css/AuditionBookingWizard.css'; // Main CSS for the wizard
import CastingFeedback from '../../pages/dashboard/talent/CastingFeedback';
import Modal from 'react-bootstrap/Modal';

const AuditionBookingWizard = ({ audition }) => {
    const { isAuthenticated, user, login } = useAuth();
    const [currentStep, setCurrentStep] = useState(1);
    const [selectedMode, setSelectedMode] = useState(''); // ONLINE, F2F, WALKIN
    const [loading, setLoading] = useState(false); // Global loading for payment/major actions
    const [apiError, setApiError] = useState(''); // Global API error for main wizard
    const [appId, setAppId] = useState(''); // Application ID for display
    const [hasActiveApplication, setHasActiveApplication] = useState(false);
    const [initialLoading, setInitialLoading] = useState(true); // Loading for initial app status check
    const [existingApplicationDetails, setExistingApplicationDetails] = useState(null);

    // --- Video Upload States (Step 4) ---
    const [status, setStatus] = useState(""); // General status message for upload
    const [compressProgress, setCompressProgress] = useState(0);
    const [uploadProgress, setUploadProgress] = useState(0);
    const [originalSize, setOriginalSize] = useState("");
    const [compressedSize, setCompressedSize] = useState("");
    
    // --- Scheduler States (Step 1) ---
    const [selectedDate, setSelectedDate] = useState('');
    const [selectedTimeSlot, setSelectedTimeSlot] = useState(null);
    const scrollRef = useRef(null); // For date strip scrolling
    const [availableSlots, setAvailableSlots] = useState([]);
    const [loadingSlots, setLoadingSlots] = useState(false);
    const [slotError, setSlotError] = useState('');
    const [selectedSlotId, setSelectedSlotId] = useState(null);

    // --- Payment Modal States (Step 2) ---
    const [showPaymentModal, setShowPaymentModal] = useState(false);
    const [checkoutUrl, setCheckoutUrl] = useState('');
    const [applicationDbId, setApplicationDbId] = useState(null);
    const [applicationJogetId, setApplicationJogetId] = useState(null);
    const pollingRef = useRef(null);

    // --- Script/Scene States (Step 3) ---
    const [sceneScript, setSceneScript] = useState({
        roleScene: "",
        roleScript: "",
        storyLine: "",
        characterSketch: ""
    });

    // --- Inline Auth States (Step 2) ---
    const [nameInput, setNameInput] = useState('');
    const [emailInput, setEmailInput] = useState('');
    const [mobileInput, setMobileInput] = useState('');
    const [otpInput, setOtpInput] = useState('');
    const [showInlineOtpSection, setShowInlineOtpSection] = useState(false);
    const [isSendingAuthOtp, setIsSendingAuthOtp] = useState(false);
    const [isVerifyingAuthOtp, setIsVerifyingAuthOtp] = useState(false);
    const [authError, setAuthError] = useState('');
    const [currentAuthAction, setCurrentAuthAction] = useState('');
    const [authUserId, setAuthUserId] = useState(null);
    const [newRegisterUser, setNewRegisterUser] = useState(null);
    const [timer, setTimer] = useState(60);
    const [resendDisabled, setResendDisabled] = useState(false);
    const [couponCode, setCouponCode] = useState('');
    const [couponData, setCouponData] = useState(null);
    const [couponError, setCouponError] = useState('');
    const [applyingCoupon, setApplyingCoupon] = useState(false);

    // --- Audition Details (Step 5) ---
    const [auditionDetails, setAuditionDetails] = useState(null);
    const [loadingDetails, setLoadingDetails] = useState(false);
    const [showVideoModal, setShowVideoModal] = useState(false); // Global modal state for video playback
    const [activeVideoUrl, setActiveVideoUrl] = useState(''); // Global active video URL
    const [
    showFeedbackModal,
    setShowFeedbackModal
] = useState(false);

    // --- Video Re-upload states (Step 5 - Candidate side) ---
    const [selectedVideoFileForReupload, setSelectedVideoFileForReupload] = useState(null);
    const [reuploadingVideo, setReuploadingVideo] = useState(false);
    const [reuploadProgress, setReuploadProgress] = useState(0);
    const [reuploadError, setReuploadError] = useState('');
    const reuploadFileInputRef = useRef(null); // Ref for file input in re-upload section

    // --- Derived Properties ---
    const allowedModes = audition?.auditionType ? audition.auditionType.toLowerCase() : "";
    const roleLocalId = audition?.roleLocalId || "";
    const showOnline = allowedModes.includes('online');
    const showF2F = allowedModes.includes('facetoface') || allowedModes.includes('face to face');
    const showWalkin = allowedModes.includes('walkin') || allowedModes.includes('walk-in');

    const bookingMode =
        selectedMode === 'ONLINE'
            ? 'VIDEO_UPLOAD'
            : selectedMode === 'F2F'
            ? 'FACE_TO_FACE'
            : selectedMode === 'WALKIN'
            ? 'SLOT_BOOKING'
            : '';

    // --- Effects ---

    // Effect to check application status on mount/auth change
    useEffect(() => {
        const checkApplicationStatus = async () => {
            if (!audition?.jobIdForBooking) return; // Ensure audition data is loaded
            
            setInitialLoading(true);
            setApiError('');

            // Reset states if not authenticated
            if (!isAuthenticated) {
                setNameInput(''); setEmailInput(''); setMobileInput('');
                setShowInlineOtpSection(false); setAuthError('');
                setHasActiveApplication(false); setExistingApplicationDetails(null);
                setSceneScript({ roleScene: "", roleScript: "",storyLine:"", characterSketch:"" });
                setAppId(''); setApplicationDbId(null); setApplicationJogetId(null);
                setCurrentStep(1);
                setTimer(60); setResendDisabled(false);
                setInitialLoading(false);
                return;
            }

            // Set user info if authenticated
            if (user) {
                setNameInput(user.full_name || '');
                setEmailInput(user.email || '');
                setMobileInput(user.mobile_no || '');
            }

            const roleUuid = audition.jobIdForBooking || audition.id; 
            try {
                const response = await fetchRoleCheckApplicationByIdApi(roleUuid);
                console.log("Check Application Status Response (Candidate):", response.data);

                if (response.data.success && response.data.isApplied) {
                    const appDetails = response.data.applicationDetails;
                    setHasActiveApplication(true);
                    setExistingApplicationDetails(appDetails);

                    setSceneScript({
                        roleScene: response.data.sceneScriptDetails?.roleScene || audition.roleScene || "No scene details available.",
                        roleScript: response.data.sceneScriptDetails?.roleScript || audition.roleScript || "No script details provided.",
                        storyLine: response.data.sceneScriptDetails?.storyLine || audition.storyLine || "No story line details provided.",
                        characterSketch: response.data.sceneScriptDetails?.characterSketch || audition.characterSketch || "No character sketch details provided."
                    });

                    setAppId(appDetails.applicationId || "");
                    setApplicationDbId(appDetails.mysqlApplicationId);
                    setApplicationJogetId(appDetails.jogetApplicationId);

                    let uiMode = '';
                    if (appDetails.bookingType === 'VIDEO_UPLOAD') uiMode = 'ONLINE';
                    else if (appDetails.bookingType === 'ONLINE_MEETING') uiMode = 'F2F';
                    else if (appDetails.bookingType === 'SLOT_BOOKING') uiMode = 'WALKIN';
                    setSelectedMode(uiMode);

                    // Determine starting step based on the application's current state
                    // if(appDetails.result === 'REJECTED' || appDetails.bookingStatus === 'SELECTED' || appDetails.bookingStatus === 'COMPLETED') {
                    //     setCurrentStep(5); // Go to details step  
                    // }else{
                    //     if (appDetails.result === 'RESUBMIT' && appDetails.bookingType === 'VIDEO_UPLOAD') {
                    //         setCurrentStep(5); // Go directly to step 5 for re-upload
                    //     } else if (appDetails.videoUploaded === true && appDetails.bookingType === 'VIDEO_UPLOAD') {
                    //         setCurrentStep(5); // Video uploaded, go to step 5 to see details
                    //     } else if (appDetails.bookingStatus === 'BOOKED' || appDetails.bookingStatus === 'APPLIED') {
                    //         if (appDetails.bookingType === 'VIDEO_UPLOAD' && appDetails.videoUploaded !== true) {
                    //             setCurrentStep(4); // Go to upload step
                    //         } else {
                    //             setCurrentStep(5); // Go to details step
                    //         }
                    //     } else {   
                    //         setCurrentStep(3); // Default to script if application exists but not fully processed
                    //     }
                    // }

                if (
                    appDetails.paymentStatus === 'FAILED' ||
                    appDetails.paymentStatus === 'IN_PROGRESS'
                ) {

                    // ✅ KEEP USER ON PAYMENT STEP
                    setCurrentStep(2);

                }

                else if (
                    appDetails.result === 'REJECTED' ||
                    appDetails.bookingStatus === 'SELECTED' ||
                    appDetails.bookingStatus === 'COMPLETED'
                ) {

                    setCurrentStep(5);

                }

                else {

                    if (
                        appDetails.result === 'RESUBMIT' &&
                        appDetails.bookingType === 'VIDEO_UPLOAD'
                    ) {

                        setCurrentStep(5);

                    }

                    else if (
                        appDetails.videoUploaded === true &&
                        appDetails.bookingType === 'VIDEO_UPLOAD'
                    ) {

                        setCurrentStep(5);

                    }

                    else if (
                        appDetails.bookingStatus === 'BOOKED' ||
                        appDetails.bookingStatus === 'APPLIED'
                    ) {

                        if (
                            appDetails.bookingType === 'VIDEO_UPLOAD' &&
                            appDetails.videoUploaded !== true
                        ) {

                            setCurrentStep(4);

                        } else {

                            setCurrentStep(5);

                        }

                    }

                    else {

                        setCurrentStep(3);

                    }
                }

                } else {
                    setHasActiveApplication(false);
                    setCurrentStep(1);
                }
            } catch (err) {
                console.error("Error checking application status:", err);
                setApiError(err?.response?.data?.message || 'Failed to check application status.');
                setHasActiveApplication(false);
                setCurrentStep(1);
            } finally {
                setInitialLoading(false);
            }
        };

        if (audition?.jobIdForBooking) { // Only run if audition data is available
            checkApplicationStatus();
        }
    }, [audition, isAuthenticated, user]); // Include audition in dependencies

    // Effect to fetch full audition details for Step 5
    useEffect(() => {
        const fetchAuditionDetailsForStep5 = async () => {
            if (!applicationJogetId) return;
            try {
                setLoadingDetails(true);
                setApiError('');
                const res = await fetchCurrentAuditionDetailsApi(applicationJogetId);
                console.log("Fetched Audition Details for Step 5 (Candidate):", res.data);
                if (res.data.success && res.data.data) {
                    setAuditionDetails(res.data.data);
                } else {
                    setApiError(res.data.message || "Failed to load audition details.");
                }
            } catch (err) {
                console.error("Error fetching audition details for Step 5:", err);
                setApiError(err?.response?.data?.message || "An error occurred while loading audition details.");
            } finally {
                setLoadingDetails(false);
            }
        };

        if (currentStep === 5 && applicationJogetId) {
            fetchAuditionDetailsForStep5();
        }
    }, [currentStep, applicationJogetId]);

    // Effect for OTP timer
    useEffect(() => {
        let interval;
        if (resendDisabled && timer > 0) {
            interval = setInterval(() => {
                setTimer((prev) => prev - 1);
            }, 1000);
        } else if (timer === 0) {
            setResendDisabled(false);
            clearInterval(interval);
        }
        return () => clearInterval(interval);
    }, [resendDisabled, timer]);

    // --- Handlers ---

    const handleScroll = useCallback((direction) => {
        if (!scrollRef.current) return;
        const scrollAmount = 300;
        scrollRef.current.scrollBy({
            left: direction === "left" ? -scrollAmount : scrollAmount,
            behavior: "smooth"
        });
    }, []);

    const handleSelectMode = useCallback(async (mode) => {
        if (selectedMode === mode) {
            setSelectedMode('');
            return;
        }
        setSelectedMode(mode);
        setSelectedTimeSlot(null);
        setAvailableSlots([]);
        setSlotError('');

        if (mode === 'F2F' || mode === 'WALKIN') {
            try {
                setLoadingSlots(true);
                const roleUuid = audition?.jobIdForBooking || audition?.id;
                // const auditionType = mode === 'F2F' ? 'faceToFace' : 'walkIn';
                const auditionType = mode === 'F2F' ? 'faceToFace' : 'walkin';
                const res = await fetchRoleSchedulePublicByIdApi(roleUuid, auditionType);
                if (res.data.success) {
                    const formattedSlots = res.data.data.map(slot => ({
                        ...slot,
                        dateOnly: slot.slot_date.split("T")[0],
                        timeOnly: slot.slot_time.slice(0, 5)
                    }));
                    setAvailableSlots(formattedSlots);
                } else {
                    setSlotError(res.data.message || "No slots available");
                }
            } catch (err) {
                console.error("Schedule error:", err);
                setSlotError("Failed to load slots");
            } finally {
                setLoadingSlots(false);
            }
        }
    }, [selectedMode, audition?.jobIdForBooking, audition?.id]);


    const handleUnauthenticatedPaymentFlow = async () => {
        setAuthError('');
        if (!nameInput || !emailInput || !mobileInput) {
            setAuthError('Please fill in your Full Name, Email, and Mobile Number.');
            return;
        }
        if (!emailInput.includes('@') && mobileInput.length < 10) {
            setAuthError('Please enter a valid Email or Mobile Number.');
            return;
        }

        setIsSendingAuthOtp(true);
        try {
            const contactToSendOtp = emailInput;
            const response = await sendOtpApi({ contact: contactToSendOtp });

            if (response.data.success) {
                setAuthError('');
                setShowInlineOtpSection(true);
                setCurrentAuthAction(response.data.action);
                setAuthUserId(response.data.userId || null);
                alert(`OTP sent to ${contactToSendOtp}. Please check your ${emailInput ? 'email' : 'mobile'}.`);
                setResendDisabled(true);
                setTimer(60);
            } else {
                setAuthError(response.data.message || "Failed to send OTP.");
            }
        } catch (err) {
            console.error("Error sending OTP:", err);
            setAuthError(err?.response?.data?.message || "Failed to send OTP. Please try again.");
        } finally {
            setIsSendingAuthOtp(false);
        }
    };

    const handleVerifyInlineOtp = async () => {
        setAuthError('');
        if (!otpInput) {
            setAuthError('Please enter the OTP.');
            return;
        }

        setIsVerifyingAuthOtp(true);
        const contactForVerification = emailInput;

        try {
            let response;
            if (currentAuthAction === 'login') {
                response = await verifyOtpApi({ contact: contactForVerification, otp: otpInput });
            } else if (currentAuthAction === 'register') {
                const payload = {
                    userId: authUserId,
                    fullName: nameInput,
                    otp: otpInput
                };
                if (emailInput) payload.email = emailInput;
                if (mobileInput) payload.mobileNumber = mobileInput;
                response = await registerWithOtpApi(payload);
            } else {
                setAuthError("Unknown authentication action. Please restart the process.");
                setIsVerifyingAuthOtp(false);
                return;
            }

            if (response.data.success && response.data.token) {
                login(response.data.token);
                setNewRegisterUser(response.data);
                setShowInlineOtpSection(false);
                setAuthError('');
                alert("Authentication successful! Proceeding to payment.");
                setLoading(true);
                setTimeout(() => {                    
                    setCurrentStep(2); // Stay on payment step, just re-evaluate
                    handlePaymentSubmit(response.data.user?.joget_user_id);
                }, 2000);
            } else {
                setAuthError(response.data.message || "OTP verification failed.");
            }
        } catch (err) {
            console.error("Error verifying OTP/registering:", err);
            setAuthError(err?.response?.data?.message || "Authentication failed. Please try again.");
        } finally {
            setIsVerifyingAuthOtp(false);
        }
    };

    const handleResendOtp = async () => {
        setAuthError('');
        setIsSendingAuthOtp(true);
        
        try {
            const contactToSendOtp = emailInput || mobileInput;
            const response = await sendOtpApi({ contact: contactToSendOtp });

            if (response.data.success) {
                alert(`New OTP has been sent to ${contactToSendOtp}.`);
                setResendDisabled(true);
                setTimer(60);
            } else {
                setAuthError(response.data.message || "Failed to resend OTP.");
            }
        } catch (err) {
            console.error("Error resending OTP:", err);
            setAuthError(err?.response?.data?.message || "Failed to resend OTP. Please try again.");
        } finally {
            setIsSendingAuthOtp(false);
        }
    };

    const handlePaymentSubmit = async (passedJogetId = null) => {
        const roleUuid = audition.jobIdForBooking || audition.id;
        const shortRoleId = audition.roleld;
        setLoading(true);
        setApiError('');

        const generatedAppId = "APP-" + Math.floor(Math.random() * 900000 + 100000);
        setAppId(generatedAppId);

        try {
            const userIdToUse = passedJogetId || user?.joget_user_id || newRegisterUser?.user?.joget_user_id;

            if (!userIdToUse) { throw new Error("User ID is not available for applying to the role."); }
            
            

            // let paymentAmount =
            // Number(
            //     audition?.final_amount ||
            //     audition?.finalAmount ||
            //     audition?.price ||
            //     545
            // );

            const baseAmount =
                Number(
                    audition?.price ||
                    audition?.final_amount ||
                    0
                );
                let auditionTypeCost = 0;

        const auditionCosts =
            audition?.allCosts?.find(
                c => c.type === 'auditionType'
            );

        if (auditionCosts) {

            const details =
                typeof auditionCosts.details === 'string'
                    ? JSON.parse(auditionCosts.details || '[]')
                    : (auditionCosts.details || []);

            const modeMap = {
                ONLINE: 'online',
                WALKIN: 'walkin',
                F2F: 'facetoface'
            };

            const selectedType =
                modeMap[selectedMode] || '';

            const normalize = (v) =>
                String(v || '')
                    .toLowerCase()
                    .replace(/[\s-]+/g, '');

            const matched =
                details.find(
                    d =>
                        normalize(d.label) ===
                        normalize(selectedType)
                );

            if (matched) {

                auditionTypeCost =
                    Number(matched.value || 0);
            }
        }

        // =========================
        // SUBTOTAL
        // =========================

        const subtotal =
            baseAmount + auditionTypeCost;
            const gstAmount =
                subtotal * 0.09;

            let paymentAmount =
                Math.round(subtotal + gstAmount);


            if (couponData) {

                const discountValue =
                    Number(couponData.discount || 0);

                // FIXED DISCOUNT
                if (couponData.type === "fix") {

                    paymentAmount =
                        paymentAmount - discountValue;

                }

                // PERCENTAGE DISCOUNT
                else if (couponData.type === "per") {

                    paymentAmount =
                        paymentAmount -
                        (
                            paymentAmount *
                            discountValue
                        ) / 100;
                }

                // NEGATIVE PREVENT
                if (paymentAmount < 0) {
                    paymentAmount = 0;
                }

                // ROUND VALUE
                paymentAmount =
                    Math.round(paymentAmount);
            }

            const payload = {
                roleId: roleUuid,
                roleLocalId: roleLocalId,
                roleld: shortRoleId,
                auditionDate: selectedDate,
                auditionTime: selectedTimeSlot || "Immediate",
                slotId: selectedSlotId,
                applicationId: generatedAppId,
                bookingStatus: "IN_PROGRESS",
                userId: userIdToUse,
                BookingType: bookingMode,
                rolePostBy: audition?.drcrUserId || audition.rolePostBy,
                totalAmount: paymentAmount
            };
            
            const applyResponse = await applyToRoleApi(payload);

            if (!applyResponse.data.success) { throw new Error(applyResponse.data.message || "Application failed."); }

            setApplicationDbId(applyResponse.data.mysqlApplicationId);
            setApplicationJogetId(applyResponse.data.jogetApplicationId);
          
            console.log("===== PAYMENT SUBMIT DEBUG =====");

            const description = `Audition Fee - ${audition.roleName || shortRoleId}`;

            const gatewayRes =
                await getActiveGatewayApi();

        const provider =
        gatewayRes.data.provider;
        if (provider === "dummy") {

            const paymentResponse = await fetch(
                "https://extapi.jacuji.com/api/payments/orders",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer 0NmEgdBTayoKx09ZJCAD8Aiu9qsEki4ikHF6jxXT9OnMSYiorGwkmFsZiXwziuAPAIRkz4nz9SEoBenub0PqnprkGbw9ejfutPMmh4lDfXdfty1Wo9mue_8eP151lUAsDeBGkLavCT6H6nXr280tWYsEzg6nRZMACNVVbGP1C8JzdPM5aXzZiKsNzSpdD1_ppJHZkVNARVPRaEk"            },
                    body: JSON.stringify({
                        amount: Math.round(paymentAmount),
                        description
                    })
                }
            );

            const result =
            await paymentResponse.json();

            setCheckoutUrl(
                result.checkoutUrl
            );

            setShowPaymentModal(true);

            
       startPaymentPolling(
    result.order.orderId,
    roleUuid,
    applyResponse.data.mysqlApplicationId,
    applyResponse.data.jogetApplicationId
);

        }
        else if (provider === "razorpay") {

            await openRazorpayCheckout(

                paymentAmount,

                applyResponse.data.mysqlApplicationId,

                applyResponse.data.jogetApplicationId,

                roleUuid
            );
        }

        } catch (err) {
            console.error("❌ Error during payment submission:", err);
            const errorMessage = err?.response?.data?.message || err?.message || "Something went wrong during payment processing.";
            setApiError(errorMessage);
        } finally {
            setLoading(false);
        }
    };

    const openRazorpayCheckout = async (
    paymentAmount,
    applicationDbId,
    applicationJogetId,
    roleUuid
) => {

    try {

        const orderResponse =
            await createPaymentOrderApi({
                amount: paymentAmount
            });

        if (!orderResponse.data.success) {

            throw new Error(
                orderResponse.data.message
            );
        }

        const order =
            orderResponse.data.data;
            console.log("ORDER RESPONSE FULL =>", orderResponse);
console.log("ORDER RESPONSE DATA =>", orderResponse.data);
console.log("RAZORPAY KEY =>", orderResponse?.data?.key);
console.log("ORDER =>", order);


        const options = {

            key:
                orderResponse.data.key ||
                order.key_id,

            amount:
                order.amount,

            currency:
                order.currency,

            name:
                "BookMyAudition",

            description:
                "Audition Booking Payment",

            order_id:
                order.id,

            handler: async function (response) {
                setLoading(true);

                try {

                    const verifyRes =
                        await verifyPaymentApi({

                            razorpay_order_id:
                                response.razorpay_order_id,

                            razorpay_payment_id:
                                response.razorpay_payment_id,

                            razorpay_signature:
                                response.razorpay_signature
                        });

                    if (
                        verifyRes.data.success
                    ) {

                        await updateApplicationPaymentStatusApi({

                            applicationDbId,

                            jogetApplicationId:
                                applicationJogetId,

                            roleId:
                                roleUuid,

                            bookingStatus:
                                "BOOKED",

                            paymentId:
                                response.razorpay_payment_id,

                            paymentDetails:
                                response,

                            newStatus:
                                "BOOKED",

                            slotId:
                                selectedSlotId
                        });

                        const sceneRes =
                            await fetchRoleSceneScriptByIdApi(
                                roleUuid
                            );

                        if (
                            sceneRes?.data?.data?.length > 0
                        ) {

                            const scriptData =
                                sceneRes.data.data[0];

                            setSceneScript({

                                roleScene:
                                    scriptData.roleScene,

                                roleScript:
                                    scriptData.roleScript
                            });
                        }

                        setCurrentStep(3);
                        setLoading(false);

                    } else {

                        setApiError(
                            "Payment Verification Failed"
                        );
                    }

                } catch (err) {

                    console.error(err);

                    setApiError(
                        "Payment Verification Failed"
                    );
                }
            },

            theme: {
                color: "#dc3545"
            }
        };
        console.log("RAZORPAY OPTIONS =>", options);
        const razorpay =
            new window.Razorpay(options);

        razorpay.open();

    } catch (err) {

        console.error(err);

        setApiError(
            err?.response?.data?.message ||
            err.message
        );
    }
};

    const handleRetryPayment = async () => {
         const roleUuid =
        audition.jobIdForBooking ||
        audition.id;

    const description =
        `Audition Fee - ${audition.roleName}`;

        try {

            setLoading(true);

            setApiError('');

            // let paymentAmount =
            // Number(
            //     audition?.roleCost?.totalAmount ||
            //     audition?.finalAmount ||
            //     audition?.final_amount ||
            //     audition?.price ||
            //     545
            // );
            const baseAmount =
                Number(
                    audition?.price ||
                    audition?.final_amount ||
                    0
                );
                let auditionTypeCost = 0;

            const auditionCosts =
                audition?.allCosts?.find(
                    c => c.type === 'auditionType'
                );

            if (auditionCosts) {

                const details =
                    typeof auditionCosts.details === 'string'
                        ? JSON.parse(auditionCosts.details || '[]')
                        : (auditionCosts.details || []);

                const modeMap = {
                    ONLINE: 'online',
                    WALKIN: 'walkin',
                    F2F: 'facetoface'
                };

                const selectedType =
                    modeMap[selectedMode] || '';

                const normalize = (v) =>
                    String(v || '')
                        .toLowerCase()
                        .replace(/[\s-]+/g, '');

                const matched =
                    details.find(
                        d =>
                            normalize(d.label) ===
                            normalize(selectedType)
                    );

                if (matched) {

                    auditionTypeCost =
                        Number(matched.value || 0);
                }
            }

            // =========================
            // SUBTOTAL
            // =========================

            const subtotal =
                baseAmount + auditionTypeCost;
            //     const gstAmount =
            //     Math.round(subtotal * 0.09);

            // let paymentAmount =
            //     Math.round(subtotal + gstAmount);
             const gstAmount =
                subtotal * 0.09;

            let paymentAmount =
                Math.round(subtotal + gstAmount);

            if (couponData) {

                const discountValue =
                    Number(couponData.discount || 0);

                if (couponData.type === "fix") {

                    paymentAmount =
                        paymentAmount - discountValue;

                }

                else if (couponData.type === "per") {

                    paymentAmount =
                        paymentAmount -
                        (
                            paymentAmount *
                            discountValue
                        ) / 100;
                }

                if (paymentAmount < 0) {

                    paymentAmount = 0;

                }

                paymentAmount =
                    Math.round(paymentAmount);
            }

            const gatewayRes =
                await getActiveGatewayApi();

        const provider =
        gatewayRes.data.provider;
        if (provider === "dummy") {

            const paymentResponse = await fetch(
                "https://extapi.jacuji.com/api/payments/orders",
                {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer 0NmEgdBTayoKx09ZJCAD8Aiu9qsEki4ikHF6jxXT9OnMSYiorGwkmFsZiXwziuAPAIRkz4nz9SEoBenub0PqnprkGbw9ejfutPMmh4lDfXdfty1Wo9mue_8eP151lUAsDeBGkLavCT6H6nXr280tWYsEzg6nRZMACNVVbGP1C8JzdPM5aXzZiKsNzSpdD1_ppJHZkVNARVPRaEk"            },
                    body: JSON.stringify({
                        amount: Math.round(paymentAmount),
                        description
                    })
                }
            );

            const result =
            await paymentResponse.json();

            setCheckoutUrl(
                result.checkoutUrl
            );

            setShowPaymentModal(true);

        startPaymentPolling(
    result.order.orderId,
    roleUuid,
    existingApplicationDetails.mysqlApplicationId,
    existingApplicationDetails.jogetApplicationId
);

        }
        else if (provider === "razorpay") {

            await openRazorpayCheckout(

    paymentAmount,

    existingApplicationDetails.mysqlApplicationId,

    existingApplicationDetails.jogetApplicationId,

    roleUuid
);
        }

        } catch (err) {

            console.error(err);

            setApiError(
                err.message || "Retry payment failed"
            );

        } finally {

            setLoading(false);

        }
    };

    const startPaymentPolling = (orderId, roleUuid, applicationDbId, applicationJogetId) => {
        if (pollingRef.current) {
            clearInterval(pollingRef.current);
        }

        const interval = setInterval(async () => {
            try {
                const res = await fetch(
                    `https://extapi.jacuji.com/api/payments/status/${orderId}`,
                    {
                        method: "GET",
                        headers: {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer 0NmEgdBTayoKx09ZJCAD8Aiu9qsEki4ikHF6jxXT9OnMSYiorGwkmFsZiXwziuAPAIRkz4nz9SEoBenub0PqnprkGbw9ejfutPMmh4lDfXdfty1Wo9mue_8eP151lUAsDeBGkLavCT6H6nXr280tWYsEzg6nRZMACNVVbGP1C8JzdPM5aXzZiKsNzSpdD1_ppJHZkVNARVPRaEk"
                        }
                    }
                );
                const data = await res.json();
                console.log("Payment Status Polling:", data);

                // if (data.status === "PAID") {
                //     clearInterval(interval);
                //     pollingRef.current = null;
                //     setShowPaymentModal(false);
                //     setLoading(true);
                //      if (couponCode && couponData) {

                //         await confirmCouponUsage({
                //             code: couponCode,
                //             userId: user?.id || 0
                //         });

                //     }

                //     await updateApplicationPaymentStatusApi({
                //         applicationDbId: applicationDbId,
                //         jogetApplicationId: applicationJogetId,
                //         roleId: roleUuid,
                //         bookingStatus: "BOOKED",
                //         paymentId: data.order.paymentId,
                //         paymentDetails: data,
                //         newStatus: "BOOKED",
                //         slotId: selectedSlotId
                //     });

                //     const sceneRes = await fetchRoleSceneScriptByIdApi(roleUuid);
                //     if (sceneRes?.data?.data?.length > 0) {
                //         const scriptData = sceneRes.data.data[0];
                //         setSceneScript({
                //             roleScene: scriptData.roleScene,
                //             roleScript: scriptData.roleScript
                //         });
                //     }
                    
                //     setLoading(false);
                //     setCurrentStep(3); // Move to Step 3 (Script/Scene)

                if (data.status === "PAID") {

                    clearInterval(interval);

                    pollingRef.current = null;

                    setShowPaymentModal(false);

                    setLoading(true);

                    if (couponCode && couponData) {

                        await confirmCouponUsage({
                            code: couponCode,
                            userId: user?.id || 0
                        });

                    }

                    await updateApplicationPaymentStatusApi({
                        applicationDbId: applicationDbId,
                        jogetApplicationId: applicationJogetId,
                        roleId: roleUuid,
                        bookingStatus: "BOOKED",
                        paymentId: data.order.paymentId,
                        paymentDetails: data,
                          paymentDetails: {
                                ...data,
                                method: data?.order?.method || data?.payment?.method || data?.method || "UPI" 
                            },
                        newStatus: "BOOKED",
                        slotId: selectedSlotId
                    });

                    const sceneRes =
                        await fetchRoleSceneScriptByIdApi(roleUuid);

                    if (sceneRes?.data?.data?.length > 0) {

                        const scriptData =
                            sceneRes.data.data[0];

                        setSceneScript({
                            roleScene: scriptData.roleScene,
                            roleScript: scriptData.roleScript
                        });
                    }

                    setLoading(false);

                    setCurrentStep(3);
                }

                else if (
                    data.status === "FAILED" ||
                    data.status === "CANCELLED" ||
                    data.status === "EXPIRED"
                ) {

                    clearInterval(interval);

                    pollingRef.current = null;

                    setShowPaymentModal(false);

                    setLoading(false);

                    await updateApplicationPaymentStatusApi({
                        applicationDbId: applicationDbId,
                        jogetApplicationId: applicationJogetId,
                        roleId: roleUuid,
                        bookingStatus: "FAILED",
                        paymentId: null,
                        paymentDetails: data,
                        newStatus: "FAILED",
                        slotId: selectedSlotId
                    });

                    setApiError(
                        "Payment failed or cancelled."
                    );

                }
            } catch (err) {
                setLoading(false);
                console.error("Polling error:", err);
                setApiError("Error checking payment status. Please contact support if payment was made.");
                clearInterval(interval);
                pollingRef.current = null;
            }
        }, 3000);
        pollingRef.current = interval;

        setTimeout(() => {
            if (pollingRef.current) {
                clearInterval(pollingRef.current);
                pollingRef.current = null;
                console.warn("Payment polling timed out.");
            }
        }, 5 * 60 * 1000); // 5 minutes
    };

    const handleVideoUpload = async (file, isReupload = false) => {
        // Clear previous error
        if(isReupload) setReuploadError("");
        else setStatus("");

        if (!file) {
            if(isReupload) setReuploadError("Please select a video file to upload.");
            else setStatus("Please select a video file to upload.");
            return;
        }

        if (!applicationJogetId) {
            alert("Application ID missing. Please apply first.");
            return;
        }

        if (!file.type.startsWith("video/")) {
            alert("Only video files allowed.");
            return;
        }

        const fileSizeMB = file.size / (1024 * 1024);

        if (fileSizeMB > MAX_SIZE_MB) {
            alert(`Video must not exceed ${MAX_SIZE_MB}MB.`);
            return;
        }

        const videoElement = document.createElement("video");
        videoElement.preload = "metadata";
        videoElement.src = URL.createObjectURL(file);

        videoElement.onloadedmetadata = async () => {
            window.URL.revokeObjectURL(videoElement.src); // Clean up URL

            if (videoElement.duration > MAX_DURATION_SEC) {
                alert(`Video must not exceed ${MAX_DURATION_SEC / 60} minutes.`);
                return;
            }

            if (isReupload) {
                setReuploadingVideo(true);
                setReuploadError('');
                setReuploadProgress(0);
            } else {
                setLoading(true);
                setStatus("Preparing video...");
                setCompressProgress(0);
                setUploadProgress(0);
            }
            
            setOriginalSize(fileSizeMB.toFixed(2) + " MB");

            let finalFile = file;

            try {
                if (fileSizeMB > COMPRESS_THRESHOLD_MB) {
                    if (isReupload) setReuploadError("Compressing video...");
                    else setStatus("Compressing video...");
                    finalFile = await clientCompress(file, setCompressProgress); // Pass setCompressProgress
                } else {
                    if (isReupload) setReuploadError("Uploading directly...");
                    else setStatus("Uploading directly...");
                }
                
                console.log("Compression completed. Final size:", (finalFile.size / 1024 / 1024).toFixed(2) + " MB");
                setCompressedSize((finalFile.size / 1024 / 1024).toFixed(2) + " MB"); // Set compressed size here

                const formData = new FormData();
                if (finalFile instanceof Blob && !(finalFile instanceof File)) {
                    formData.append("auditionVideo", finalFile, "compressed_video.webm");
                } else {
                    formData.append("auditionVideo", finalFile);
                }
                formData.append("jogetApplicationId", applicationJogetId);

                await uploadAuditionVideoApi(formData, {
                    onUploadProgress: (progressEvent) => {
                        const percent = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                        if (isReupload) setReuploadProgress(percent);
                        else setUploadProgress(percent);
                    }
                });

                if (isReupload) {
                    setReuploadError("✅ Upload successful!");
                    setSelectedVideoFileForReupload(null);
                    if (reuploadFileInputRef.current) {
                        reuploadFileInputRef.current.value = '';
                    }
                    // Refetch audition details to update the video URL and clear RESUBMIT status
                    const res = await fetchCurrentAuditionDetailsApi(applicationJogetId);
                    if (res.data.success && res.data.data) {
                        setAuditionDetails(res.data.data);
                    }
                } else {
                    setStatus("✅ Upload successful!");
                    setTimeout(() => {
                        setCurrentStep(5);
                    }, 1500);
                }

            } catch (err) {
                console.error(err);
                if (isReupload) setReuploadError(err?.response?.data?.message || "❌ Re-upload failed");
                else setStatus(err?.response?.data?.message || "❌ Upload failed");
            } finally {
                if (isReupload) setReuploadingVideo(false);
                else setLoading(false);
            }
        };

        videoElement.onerror = () => {
            alert("Invalid video file.");
            if (isReupload) setReuploadError("Invalid video file.");
            else setStatus("Invalid video file.");
        };
    };

    // Handlers for file inputs
    const handleInitialUploadFileChange = (e) => {
        handleVideoUpload(e.target.files[0], false);
    };

    const handleReuploadFileChange = (e) => {
        setReuploadError('');
        setSelectedVideoFileForReupload(e.target.files[0]);
    };

    const handleReuploadButtonClick = () => {
        if (selectedVideoFileForReupload) {
            handleVideoUpload(selectedVideoFileForReupload, true);
        } else {
            setReuploadError("Please select a video file to re-upload.");
        }
    };

    const handleApplyCoupon = async () => {

        if (!couponCode) {
            setCouponError("Please enter coupon");
            return;
        }

        try {

            setApplyingCoupon(true);
            setCouponError('');

            // const response = await redeemCoupon(
            //     couponCode,
            //     user?.id || 0
            // );
            console.log("FULL AUDITION DATA =>", audition);

            const response = await redeemCoupon({
                code: couponCode,
                userId: user?.id || 0,

                project_type:
                    audition?.projectType ||
                    audition?.project_type || "",


                // role_category:
                //     audition?.roleCategory || "",
                role_category:
                audition?.role_category ||
                audition?.roleCategory ||
                "",

                audition_type:
                    audition?.auditionType || ""
            });

            // if (response.data.success) {

            //     setCouponData(response.data.data);

            // } else {
                if (response.data.success) {

    setCouponData({
        discount: response.data.discount,
        type: response.data.type
    });

} else {

                setCouponError(
                    response.data.message || "Invalid Coupon"
                );
            }

        } catch (err) {

            setCouponError(
                err?.response?.data?.message ||
                "Coupon Apply Failed"
            );

        } finally {

            setApplyingCoupon(false);
        }
    };
    
    const handleNext = () => {
        if (currentStep === 1) {
            if (!selectedMode) {
                setApiError("Please select an Audition Mode.");
                return;
            }
            if ((selectedMode === 'F2F' || selectedMode === 'WALKIN') && !selectedTimeSlot) {
                setApiError("Please select a time slot.");
                return;
            }
            setApiError(''); // Clear previous error
            setCurrentStep(2);
        // } else if (currentStep === 2) {
        //     if (!isAuthenticated) {
        //         if (!showInlineOtpSection) {
        //             handleUnauthenticatedPaymentFlow();
        //         } else {
        //             setApiError("Please verify your OTP to continue.");
        //         }
        //     } else {
        //         handlePaymentSubmit();
        //     }


        } else if (currentStep === 2) {

    // ✅ RETRY PAYMENT FLOW
        if (
            existingApplicationDetails &&
            (
                existingApplicationDetails.paymentStatus === "FAILED" ||
                existingApplicationDetails.paymentStatus === "IN_PROGRESS"
            )
        ) {

            handleRetryPayment();

            return;
        }

        if (!isAuthenticated) {

            if (!showInlineOtpSection) {

                handleUnauthenticatedPaymentFlow();

            } else {

                setApiError(
                    "Please verify your OTP to continue."
                );

            }

        } else {

            handlePaymentSubmit();

        }

        
        } else if (currentStep === 3) {
            if (bookingMode === 'VIDEO_UPLOAD') setCurrentStep(4);
            else setCurrentStep(5);
        } else if (currentStep === 4) {
            if (auditionDetails?.videoUrl || status.includes("successful")) {
                setCurrentStep(5);
            } else {
                setApiError("Please upload your video first.");
            }
        }
    };

    const handlePrev = () => {
        if (currentStep > 1) {
            setCurrentStep(prev => prev - 1);
            setApiError('');
        }
    };

    const handleStepClick = (stepIndex) => {
        const targetStep = stepIndex + 1;
        setApiError(''); // Clear error on any navigation attempt
    
        if (hasActiveApplication) {
            // If an application exists, only allow navigation to steps 3, 4, and 5.
            // This prevents the user from going back to Mode/Pay and resetting the state.
            if (targetStep >= 3) {
                setCurrentStep(targetStep);
            }
            // Implicitly do nothing if the user clicks step 1 or 2.
        } else {
            // For new applications, only allow navigating back to previously completed steps.
            if (targetStep < currentStep) {
                setCurrentStep(targetStep);
            }
        }
    };
    
    // --- Render Logic ---
    if (initialLoading) {
        return (
            <div className="text-center p-5"><Spinner animation="border" variant="danger" /><p className='text-white mt-3'>Loading application status...</p></div>
        );
    }

    console.log("currentStep----",currentStep);
    console.log("selectedMode----",selectedMode);
    const steps = WIZARD_STEPS(selectedMode);
    console.log("USER DATA:", user);
        return (!user || Number(user?.role_code) === 300) ? (
            <div className="audition-booking-wizard-custom">
            <h4 className="fw-bold mb-4">BOOK THIS AUDITION</h4>
            <WizardStepper currentStep={currentStep} selectedMode={selectedMode} handleStepClick={handleStepClick} />
            <WizardHeader currentStep={currentStep} selectedMode={selectedMode} />

            {apiError && <Alert variant="danger" className="mt-3">{apiError}</Alert>}
            
            <div className="wizard-content-area">
                {currentStep === 1 && (
                    <Step1_SelectMode
                        audition={audition} selectedMode={selectedMode} handleSelectMode={handleSelectMode} handleNext={handleNext}
                        showOnline={showOnline} showF2F={showF2F} showWalkin={showWalkin}
                        selectedDate={selectedDate} setSelectedDate={setSelectedDate}
                        selectedTimeSlot={selectedTimeSlot} setSelectedTimeSlot={setSelectedTimeSlot} setSelectedSlotId={setSelectedSlotId}
                        availableSlots={availableSlots} loadingSlots={loadingSlots} slotError={slotError}
                        scrollRef={scrollRef} handleScroll={handleScroll}
                    />
                )}
                {currentStep === 2 && (
                    <Step2_Payment
                        audition={audition} isAuthenticated={isAuthenticated} user={user} newRegisterUser={newRegisterUser}
                        couponCode={couponCode}
                        setCouponCode={setCouponCode}
                        applyingCoupon={applyingCoupon}
                        couponData={couponData}
                        couponError={couponError}
                        handleApplyCoupon={handleApplyCoupon}

                        apiError={apiError} authError={authError}
                        nameInput={nameInput} setNameInput={setNameInput}
                        emailInput={emailInput} setEmailInput={setEmailInput}
                        mobileInput={mobileInput} setMobileInput={setMobileInput}
                        otpInput={otpInput} setOtpInput={setOtpInput}
                        showInlineOtpSection={showInlineOtpSection}
                        isSendingAuthOtp={isSendingAuthOtp} isVerifyingAuthOtp={isVerifyingAuthOtp}
                        handleResendOtp={handleResendOtp} handleVerifyInlineOtp={handleVerifyInlineOtp}
                        timer={timer} resendDisabled={resendDisabled}
                        loading={loading} handleNext={handleNext} selectedMode={selectedMode}
                    />
                )}
                {currentStep === 3 && (
                    <Step3_ScriptScene
                        audition={audition} sceneScript={sceneScript} handleNext={handleNext}
                        initialLoading={initialLoading}
                    />
                )}
                {currentStep === 4 && (
                    <Step4_UploadVideo
                        bookingMode={bookingMode} handleNext={handleNext}
                        loading={loading} status={status}
                        compressProgress={compressProgress} uploadProgress={uploadProgress}
                        originalSize={originalSize} compressedSize={compressedSize}
                        handleInitialUploadFileChange={handleInitialUploadFileChange}
                        auditionDetails={auditionDetails}
                    />
                )}
                {currentStep === 5 && (
                    <Step5_ApplicationDetails
                        loadingDetails={loadingDetails} auditionDetails={auditionDetails} apiError={apiError}
                        applicationJogetId={applicationJogetId}
                        // Moved video playback state to here
                        showVideoModal={showVideoModal} setShowVideoModal={setShowVideoModal}
                        activeVideoUrl={activeVideoUrl} setActiveVideoUrl={setActiveVideoUrl}
                        selectedVideoFileForReupload={selectedVideoFileForReupload}
                        reuploadingVideo={reuploadingVideo} reuploadProgress={reuploadProgress}
                        reuploadError={reuploadError} reuploadFileInputRef={reuploadFileInputRef}
                        handleReuploadFileChange={handleReuploadFileChange}
                        handleReuploadButtonClick={handleReuploadButtonClick}
                        showFeedbackModal={showFeedbackModal}
                        setShowFeedbackModal={setShowFeedbackModal}
                    />
                )}
            </div>

            <PaymentModal 
                show={showPaymentModal} 
                handleClose={() => setShowPaymentModal(false)} 
                checkoutUrl={checkoutUrl}
                pollingRef={pollingRef}
            />
            <Modal
                show={showFeedbackModal}
                onHide={() =>
                    setShowFeedbackModal(false)
                }
                centered
                dialogClassName="review-modal"
            >

                <Modal.Body
                    style={{
                        padding: 0,
                        background: '#050816',
                        borderRadius: '20px'
                    }}
                >

    
            <CastingFeedback
                directorId={
                    audition?.rolePostBy
                }              
                roleId={
                    auditionDetails?.roleId
                    || audition?.roleLocalId
                }

                applicationId={auditionDetails?.applicationId}
                 roleName={
                    audition?.roleName
                }

            />

                </Modal.Body>

            </Modal>
        </div>
        ) : (

    <div className="text-center p-4">
        <h5 className="text-danger">Only for Candidate Section</h5>
    </div>
    );
};

export default AuditionBookingWizard;